import {
  ANALYTICS_EVENT,
  ANALYTICS_EVENT_ACTION,
  ANALYTICS_EVENT_CATEGORY,
  ANALYTICS_EVENT_LABEL,
  ANALYTICS_EVENT_TYPE,
} from './declarations';
import { sendTealiumEvent } from '~/utils/tealium/index';

export const handleSynchronyPrequalifyTealium = () => {
  sendTealiumEvent({
    event: ANALYTICS_EVENT.paymentformSynchronyPrequalify,
    event_category: ANALYTICS_EVENT_CATEGORY.financing,
    event_action: ANALYTICS_EVENT_ACTION.paymentformSynchronyPrequalify,
    event_label: ANALYTICS_EVENT_LABEL.paymentformSynchronyPrequalify,
    event_noninteraction: 'false',
    event_type: 'synch_button',
  });
};

export const handleCreditCardRadioTealium = () => {
  sendTealiumEvent({
    event: ANALYTICS_EVENT.paymentFormCreditCardRadio,
    event_category: ANALYTICS_EVENT_CATEGORY.checkout,
    event_action: ANALYTICS_EVENT_ACTION.paymentformPaymentMethod,
    event_label: ANALYTICS_EVENT_LABEL.paymentFormCreditCardRadio,
    event_noninteraction: 'false',
  });
};
export const handleAdyenRadioTealium = () => {
  sendTealiumEvent({
    event: ANALYTICS_EVENT.paymentFormCreditCardRadio,
    event_category: ANALYTICS_EVENT_CATEGORY.checkout,
    event_action: ANALYTICS_EVENT_ACTION.paymentformPaymentMethod,
    event_label: ANALYTICS_EVENT_LABEL.paymentFormCreditCardRadio,
    event_noninteraction: 'false',
  });
};
export const handlePaypalRadioTealium = () => {
  sendTealiumEvent({
    event: ANALYTICS_EVENT.paymentformPaypalRadio,
    event_category: ANALYTICS_EVENT_CATEGORY.checkout,
    event_action: ANALYTICS_EVENT_ACTION.paymentformPaymentMethod,
    event_label: ANALYTICS_EVENT_LABEL.paymentformPaypalRadio,
    event_noninteraction: 'false',
  });
};
export const handleSynchronyRadioTealium = () => {
  sendTealiumEvent({
    event: ANALYTICS_EVENT.paymentformSynchronyRadio,
    event_category: ANALYTICS_EVENT_CATEGORY.checkout,
    event_action: ANALYTICS_EVENT_ACTION.paymentformPaymentMethod,
    event_label: ANALYTICS_EVENT_LABEL.paymentformSynchronyRadio,
    event_noninteraction: 'false',
  });
};
export const handleAffirmRadioTealium = () => {
  sendTealiumEvent({
    event: ANALYTICS_EVENT.paymentformAffirmRadio,
    event_category: ANALYTICS_EVENT_CATEGORY.checkout,
    event_action: ANALYTICS_EVENT_ACTION.paymentformPaymentMethod,
    event_label: ANALYTICS_EVENT_LABEL.paymentformAffirmRadio,
    event_noninteraction: 'false',
  });
};
export const handleProgressiveRadioTealium = () => {
  sendTealiumEvent({
    event: ANALYTICS_EVENT.paymentformProgressiveRadio,
    event_category: ANALYTICS_EVENT_CATEGORY.checkout,
    event_action: ANALYTICS_EVENT_ACTION.paymentformPaymentMethod,
    event_label: ANALYTICS_EVENT_LABEL.paymentformProgressiveRadio,
    event_noninteraction: 'false',
  });
};

export const handleDeliveryFormWithNoDateTealium = () => {
  sendTealiumEvent({
    event: ANALYTICS_EVENT.deliveryFormWithNoDate,
    event_category: ANALYTICS_EVENT_CATEGORY.checkout,
    event_action: ANALYTICS_EVENT_ACTION.deliveryFormWithNoDate,
    event_label: ANALYTICS_EVENT_LABEL.deliveryform,
    event_noninteraction: 'false',
  });
};

export const handleFreeDeliveryServiceOptionTealium = () => {
  sendTealiumEvent({
    event: ANALYTICS_EVENT.deliveryFormFreeDeliveryServiceOption,
    event_category: ANALYTICS_EVENT_CATEGORY.checkout,
    event_action: ANALYTICS_EVENT_ACTION.deliveryFormFreeDeliveryServiceOption,
    event_label: ANALYTICS_EVENT_LABEL.deliveryform,
    event_noninteraction: 'false',
  });
};

export const handlePaymentProgressiveApplyTealium = () => {
  sendTealiumEvent({
    event: ANALYTICS_EVENT.paymentformProgressiveApply,
    event_category: ANALYTICS_EVENT_CATEGORY.financing,
    event_action: ANALYTICS_EVENT_ACTION.paymentformProgressiveSynchronyApply,
    event_label: ANALYTICS_EVENT_LABEL.paymentformProgressiveApply,
    event_noninteraction: 'false',
    event_type: 'lto_button',
  });
};

export const handleProgressiveApplyDialogueTealium = () => {
  sendTealiumEvent({
    event: ANALYTICS_EVENT.paymentformProgressiveApply,
    event_category: ANALYTICS_EVENT_CATEGORY.financing,
    event_action: ANALYTICS_EVENT_ACTION.paymentformProgressiveSynchronyApply,
    event_label: ANALYTICS_EVENT_LABEL.paymentformProgressiveApplyDialogue,
    event_noninteraction: 'false',
    event_type: 'lto_button',
  });
};

export const handleSynchronyLearnHowTealium = () => {
  sendTealiumEvent({
    event: ANALYTICS_EVENT.paymentformSynchronyLearnHow,
    event_category: ANALYTICS_EVENT_CATEGORY.internalLinks,
    event_action: ANALYTICS_EVENT_ACTION.paymentformSynchronyLearnHow,
    event_label: ANALYTICS_EVENT_LABEL.paymentformSynchronyLearnHow,
    event_noninteraction: 'false',
  });
};

export const handleSynchronyChatCallTealium = () => {
  sendTealiumEvent({
    event: ANALYTICS_EVENT.chat,
    event_type: ANALYTICS_EVENT_TYPE.chatClick,
    event_category: ANALYTICS_EVENT_CATEGORY.chat,
    event_action: 'click',
    event_label: ANALYTICS_EVENT_LABEL.chatClick,
  });
};

export const handleSynchronyApplyTealium = () => {
  sendTealiumEvent({
    event: ANALYTICS_EVENT.paymentformSynchronyApply,
    event_category: ANALYTICS_EVENT_CATEGORY.applyNow,
    event_action: ANALYTICS_EVENT_ACTION.drawerSynchronyApply,
    event_label: ANALYTICS_EVENT_LABEL.drawerSynchronyApplyandPrequalify,
  });
};

export const handleSynchronyModalPrequalifyTealium = () => {
  sendTealiumEvent({
    event: ANALYTICS_EVENT.paymentformSynchronyModalPrequalify,
    event_category: ANALYTICS_EVENT_CATEGORY.financing,
    event_action: 'Button',
    event_label: ANALYTICS_EVENT_LABEL.paymentformSynchronyPrequalify,
    event_noninteraction: 'false',
    event_type: 'synch_button',
  });
};
export const handleSynchronyDrawerApplyTealium = () => {
  sendTealiumEvent({
    event: ANALYTICS_EVENT.drawerSynchronyApply,
    event_category: ANALYTICS_EVENT_CATEGORY.drawerSynchronyApplyandPrequalify,
    event_action: ANALYTICS_EVENT_ACTION.drawerSynchronyApply,
    event_label: ANALYTICS_EVENT_LABEL.drawerSynchronyApplyandPrequalify,
  });
};

export const handleSynchronyDrawerPrequalifyTealium = () => {
  sendTealiumEvent({
    event: ANALYTICS_EVENT.drawerSynchronyPrequalify,
    event_category: ANALYTICS_EVENT_CATEGORY.drawerSynchronyApplyandPrequalify,
    event_action: ANALYTICS_EVENT_ACTION.drawerSynchronyPrequalify,
    event_label: ANALYTICS_EVENT_LABEL.drawerSynchronyApplyandPrequalify,
    event_type: 'synch_button',
  });
};

export const handleSynchronyDrawerChatTealium = () => {
  sendTealiumEvent({
    event: ANALYTICS_EVENT.chat,
    event_category: ANALYTICS_EVENT_CATEGORY.chat,
    event_type: ANALYTICS_EVENT_TYPE.chatClick,
    event_action: ANALYTICS_EVENT_ACTION.drawerSynchronyChatCallClick,
    event_label: ANALYTICS_EVENT_LABEL.chatClick,
  });
};

export const handleSynchronyDrawerCallTealium = () => {
  sendTealiumEvent({
    event: ANALYTICS_EVENT.call,
    event_category: ANALYTICS_EVENT_CATEGORY.call,
    event_type: ANALYTICS_EVENT_TYPE.callClick,
    event_action: ANALYTICS_EVENT_ACTION.drawerSynchronyChatCallClick,
    event_label: ANALYTICS_EVENT_LABEL.callClick,
  });
};
